import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const FraudManagmentOverview = ({ data }) => {
  const {
    of_fm_service_type,
    of_fm_company_name,
    of_fm_contact_name,
    of_fm_job_title,
    of_fm_phone_number,
    of_fm_email,
  } = data["4_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">Fraud Management Service</div>
        </div>
        <ReviewAttribute
          label="Service Type"
          value={of_fm_service_type?.length ? toTitleCase(of_fm_service_type) : "-"}
        />
        {of_fm_service_type === "other" && (
          <>
            <ReviewAttribute
              label="Company Name"
              value={of_fm_company_name?.length ? toTitleCase(of_fm_company_name) : "-"}
            />
            <ReviewAttribute
              label="Contact Name"
              value={of_fm_contact_name?.length ? toTitleCase(of_fm_contact_name) : "-"}
            />
            <ReviewAttribute
              label="Title"
              value={of_fm_job_title?.length ? toTitleCase(of_fm_job_title) : "-"}
            />
            <ReviewAttribute
              label="Company Phone"
              value={of_fm_phone_number?.length ? toTitleCase(of_fm_phone_number) : "-"}
            />
            <ReviewAttribute
              label="Email"
              value={of_fm_email?.length ? toTitleCase(of_fm_email) : "-"}
            />
          </>
        )}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default FraudManagmentOverview;
